import type {
  ContactStepValues,
  PersonalStepValues,
} from "../../create-employee/schemas/create-employee.schema.ts";
import type { HrSetupEmployeeRow } from "../schemas/hr-setup-employee.schema.ts";

function str(v: unknown): string {
  if (typeof v === "string") return v;
  return typeof v === "number" && Number.isFinite(v) ? String(v) : "";
}

function relationValue(
  v: unknown,
): ContactStepValues["relationWithAlternateNo"] {
  const s = str(v).toLowerCase();
  if (
    s === "mother" ||
    s === "father" ||
    s === "sister" ||
    s === "brother" ||
    s === "guardian" ||
    s === "spouse"
  ) {
    return s;
  }
  if (s === "husband" || s === "wife") {
    return s as ContactStepValues["relationWithAlternateNo"];
  }
  return "mother";
}

export function mapOnboardUserToPersonalStep(row: HrSetupEmployeeRow): PersonalStepValues {
  const childName = str(row.childName);
  const childDob = str(row.childDob ?? row.childDOB);
  const childGender = str(row.childGender).toLowerCase();
  const hasChildDetails = Boolean(childName || childDob || childGender);

  return {
    firstName: str(row.firstName),
    middleName: str(row.middleName),
    lastName: str(row.lastName),
    personalEmail: str(row.personalEmail),
    gender: (str(row.gender).trim().toLowerCase() || "male") as PersonalStepValues["gender"],
    bloodGroup: (str(row.bloodGroup) || "O+ve") as PersonalStepValues["bloodGroup"],
    dob: str(row.dob),
    aadharNumber: str(row.aadharNum ?? row.aadharNumber),
    panCardNumber: str(row.panNum ?? row.panCardNumber).toUpperCase(),
    ssn: str(row.ssn),
    zipCode: str(row.zipCode),
    passportNumber: str(row.passportNum ?? row.passportNumber).toUpperCase(),
    joiningDate: str(row.doj ?? row.joiningDate),
    maritalStatus: (str(row.maritalStatus) || "Single") as PersonalStepValues["maritalStatus"],
    anniversaryDate: str(row.anniversaryDate),
    spouseName: str(row.spouseName),
    spouseDob: str(row.spouseDob ?? row.spouseDOB),
    hasChild: hasChildDetails ? "yes" : "no",
    childName,
    childDob,
    childGender: (childGender || undefined) as PersonalStepValues["childGender"],
  };
}

export function mapOnboardUserToContactStep(row: HrSetupEmployeeRow): ContactStepValues {
  return {
    phoneNumber: str(row.phoneNumber),
    alternateNumber: str(row.alternateNumber),
    relationWithAlternateNo: relationValue(row.relationWithAlternateNo),
    alternateName: str(row.alternateName),
    presentAddress: str(row.presentAddress),
    permanentAddress: str(row.permanentAddress),
  };
}
